//
//
//
//
//
//
//
//

export default {
  name: "TextWap",
  created() {},
  props: {
    post: {
      type: Object,
      default: null
    },
    isListItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/post/TextWap.vue